import * as React from "react";
const SvgEye = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 11.556, height: 7, viewBox: "0 0 11.556 7", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", stroke: "rgba(0,0,0,0)", d: "M5.768.5A5.464 5.464 0 0 0 .513 4.48a.33.33 0 0 0 .638.164 4.806 4.806 0 0 1 9.241 0 .33.33 0 0 0 .638-.164A5.47 5.47 0 0 0 5.768.5Zm0 1.756A2.122 2.122 0 1 0 7.89 4.378a2.126 2.126 0 0 0-2.118-2.122Z" }));
export default SvgEye;
